module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-b-0",
    staticStyle: {
      "height": "35px",
      "padding-top": "7px",
      "padding-bottom": "7px"
    },
    style: ({
      'pointer-events': _vm.isEnabled ? 'all' : 'none'
    })
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.dvalue
    }
  }), _vm._v("  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277ae541"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/checkbox.vue
// module id = 547
// module chunks = 23